<style scoped lang="sass">
.el-row
  display: flex
  flex-direction: rows
  .el-col-12
    & > div
      height: 100%
</style>

<template lang='pug'>
.main-container
  
  .view-content
    el-row(:gutter='$rowGutter')

      el-col(:span='12')
        account-address(
          :label-position='labelPosition', :label-width='labelWidth',
          :backend-account='account', @change='childChangedAccount'
        )

      el-col(:span='12')
        account-contact(
          :label-position='labelPosition', :label-width='labelWidth',
          :backend-account='account', @change='childChangedAccount'
        )

    el-row(:gutter='$rowGutter', style='margin-top: 1.5rem')
      el-col(:span='12')
        account-preferences(
          :label-position='labelPosition', :label-width='labelWidth'
        )

      el-col(:span='12')
        password-changer(
          :label-position='labelPosition', :label-width='labelWidth'
        )
</template>

<script>

  import AccountPreferences from './blocks/AccountPreferences.vue'
  import PasswordChanger from './blocks/PasswordChanger.vue'
  import AccountAddress from './blocks/AccountAddress.vue'
  import AccountContact from './blocks/AccountContact.vue'

  function data(){
    return {
      labelPosition: 'right',
      labelWidth: '9rem',
      account: null
    }
  }

  function created(){
    this.getAccount()
  }

  function getAccount(){
    this.$simplecater.get('/account').then((r)=>{
      this.account = r.data.data
    }).catch(()=>{
      this.$message.error("Failed to load the account information")
    })
  }

  function childChangedAccount(newVal){
    console.log("CHILD changed account to", newVal)
    this.account = newVal
  }

  const components = {
    AccountPreferences, PasswordChanger,
    AccountAddress, AccountContact
  }

  const methods = {
    getAccount, created, childChangedAccount
  }
  const watch = {
    '$route' (to, from) {
      console.log("Reloading data")
      this.getAccount()
    }
  }

  export default { data, methods, watch, components, created }

</script>



// WEBPACK FOOTER //
// src/user/Settings.vue